import { caseDiscount, type Product } from '../../../data/product';
import { preciseCurrencyFormatter } from '../../../helpers/format-currency';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const SavingsDollars: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Savings $$',
  minWidth: 80,
  accessorFn: (product) => {
    const savings = caseDiscount(product);
    if (savings === 0) {
      return '';
    }

    return preciseCurrencyFormatter(savings);
  },
  toCSV: (product) => ({
    'Savings $$': caseDiscount(product).toFixed(2),
  }),
});
